export default {
  required: 'هذا الحقل مطلوب',
  email: 'عنوان البريد الإلكتروني غير صحيح',
  emailLength: 'يجب ألا يتجاوز عنوان البريد الإلكتروني 180 حرفًا',
  firstNameLength: 'يجب أن يحتوي هذا الحقل على ما بين 1 و 100 حرف',
  insee: 'يجب أن يكون رمز INSEE رمزًا أبجديًا رقميًا مكونًا من 5 أحرف',
  ins: 'رقم غير صالح',
  oid: 'OID غير صالح',
  phone: 'رقم الهاتف غير صحيح'
}
